import { GroupResponseDTO } from '@core/api/dtos/response/group/group'
import { Group, GroupAnalytics } from '@core/api/entities/group'
import { CampaignMapper } from '@core/api/mappers/campaign/campaignMapper'
import { PlaylistMapper } from '@core/api/mappers/playlist/playlistMapper'
import { MixMapper } from '@core/api/mappers/radio/mixMapper'
import { MusicProfileMapper } from '@core/api/mappers/radio/musicProfileMapper'
import { RadioMapper } from '@core/api/mappers/radio/radioMapper'
import { ZoneMapper } from '@core/api/mappers/zone/zoneMapper'

import { ScheduleMapper } from './scheduleMapper'

export class GroupMapper {
	static toEntity = (dto: GroupResponseDTO): Group => {
		// Handle both analytics and metadata formats
		const analyticsData = dto.analytics?.data ||
			dto.metadata || {
				players: 0,
				announcements: 0,
				mixes: 0,
				radios: 0,
			}

		// Check if metadata format (has additional fields)
		const isMetadata = dto.metadata !== undefined
		const metadata = isMetadata ? dto.metadata! : null

		return Group.create({
			id: dto.id,
			accountId: dto.account_id,
			accountName: dto.account?.data?.name,
			musicProfileId: dto.music_profile_id,
			name: dto.name,
			analytics: GroupAnalytics.create({
				players: analyticsData.players || 0,
				announcements: analyticsData.announcements || 0,
				mixes: analyticsData.mixes || 0,
				radios: analyticsData.radios || 0,
				schedules: metadata?.schedules || 0,
				playlists: metadata?.playlists || 0,
				adverts: metadata?.adverts || 0,
			}),

			radios: dto.radios?.data.map((radio) => RadioMapper.toEntity(radio)),
			campaigns: dto.announcements?.data.map((announcement) =>
				CampaignMapper.toEntity(announcement)
			),
			mixes: dto.mixes?.data.map((mix) => MixMapper.toEntity(mix)),
			zones: dto.players?.data.map((player) => ZoneMapper.toEntity(player)),
			musicProfile: dto.music_profile?.data
				? MusicProfileMapper.toEntity(dto.music_profile.data)
				: undefined,
			schedules:
				dto.schedules?.data.map((schedule) =>
					ScheduleMapper.toEntity(schedule)
				) ?? undefined,
			playlists:
				dto.playlists?.data.map((playlist) =>
					PlaylistMapper.toEntity(playlist)
				) ?? undefined,
			directPlaylists: dto.direct_playlists,
		})
	}

	static toEntities = (dtos: GroupResponseDTO[]): Group[] => {
		return dtos.map(this.toEntity)
	}
}
